// extracted by mini-css-extract-plugin
export default {"content":"Pagination_content__b6WPc"};